// TODO ZL-856: replace this custom infrastructure with Firebase Remote Config
import { getCurrentUser } from '#firebase/authStore'

import { useShowFeatureFlagsQuery } from './api'
import { useFeatureFlagUserId } from './FeatureFlagUserIdContext'

// Portal: evaluates flags for the authenticated user (getCurrentUser).
// Playground: the debugger inspects a *selected* user whose flags may differ.
// FeatureFlagUserIdContext lets the playground override the UID without
// changing hook signatures or breaking portal behavior.
export const useFeatureFlags = () => {
  const overrideUserId = useFeatureFlagUserId()
  const user = overrideUserId ? null : getCurrentUser()
  const uid = overrideUserId ?? user?.uid ?? ''

  return useShowFeatureFlagsQuery(uid, {
    enabled: !!uid,
    throwOnNotFound: false,
  })
}
